import { usePathname, useRouter } from 'expo-router';
import React, { useEffect } from 'react';
import { ScrollView, View } from 'react-native';
import Modal from 'react-native-modal';
import Toast from 'react-native-toast-message';
import {
  createStyleSheet,
  UnistylesRuntime,
  useStyles,
} from 'react-native-unistyles';

import { useCustomer } from '@/api/customers/use-customer';
import { useAuth } from '@/core';
import { Button, Text, toastConfig } from '@/ui';
import { Eon } from '@/ui/icons/eon';

import Signin from '../signin';
import Signup from '../signup';
import Navbar from './navbar';
import { useModalStore } from './store';

export const LoginModal = () => {
  const { styles, theme } = useStyles(stylesheet);
  const status = useAuth.use.status();
  const loginModalMode = useModalStore((state) => state.loginModalMode);
  const setLoginModalMode = useModalStore((state) => state.setLoginModalMode);
  const finishingSignup = useModalStore((state) => state.finishingSignup);
  const { data: customer, refetch: refetchCustomer } = useCustomer();
  const pathname = usePathname();
  const router = useRouter();

  useEffect(() => {
    if (
      status === 'signIn' &&
      !finishingSignup &&
      customer &&
      customer.setupComplete
    ) {
      setLoginModalMode('none');
    }
  }, [status, setLoginModalMode, finishingSignup, customer]);

  const isPartnerFlow =
    pathname.includes('/partner') || pathname === '/join-partner-program';
  const isEntryPage = pathname.includes('/login');

  useEffect(() => {
    if (isEntryPage && loginModalMode !== 'none') {
      setLoginModalMode('none');
    }
  }, [isEntryPage, loginModalMode, setLoginModalMode]);

  const handleContinue = () => {
    setLoginModalMode('none');
    router.push('/login');
  };

  const renderBody = () => {
    if (loginModalMode === 'signup') {
      return (
        <Signup
          onBack={() => {
            setLoginModalMode('none');
            // setLoginModalMode('home')
          }}
        />
      );
    }

    if (loginModalMode === 'signin') {
      return (
        <Signin
          onBack={() => {
            setLoginModalMode('none');
            // setLoginModalMode('home');
          }}
          onDone={() => {
            setLoginModalMode('none');
          }}
        />
      );
    }

    return (
      <View style={{ width: '100%' }}>
        {/* <MapBlack style={styles.map} /> */}

        <Navbar
          style={{ backgroundColor: 'transparent' }}
          onPress={() => {
            if (['/trips', '/account'].includes(pathname)) {
              setLoginModalMode('none');
              router.replace('/search');
              return;
            }
            setLoginModalMode('none');
          }}
          type="cancel"
        />

        <View style={styles.container}>
          <View style={styles.titleContainer}>
            <Eon
              width="88"
              height="24"
              fill={UnistylesRuntime.themeName === 'dark' ? 'white' : 'black'}
            />

            <Text type="largeTitle">
              {isPartnerFlow
                ? "You're one step from listing your cars."
                : 'Your Rental Car. Unlocked.'}
            </Text>

            {isPartnerFlow && (
              <Text
                type="bodyRegular"
                style={{ color: theme.colors.text.secondary }}
              >
                Create your owner account to get started. Takes about a minute.
              </Text>
            )}
          </View>

          <View style={styles.buttonsContainer}>
            <Button text="Continue" type="primary" onPress={handleContinue} />
          </View>
        </View>
      </View>
    );
  };

  return (
    <Modal
      animationIn="slideInUp"
      animationInTiming={300}
      animationOut="slideOutDown"
      animationOutTiming={1000}
      isVisible={loginModalMode !== 'none' && !isEntryPage}
      hasBackdrop
      onBackdropPress={() => {
        if (['/trips', '/account'].includes(pathname)) {
          setLoginModalMode('none');
          router.replace('/search');
          return;
        }
        setLoginModalMode('none');
      }}
      style={{
        margin: 0,
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <View
        style={{
          width: '100%',
          maxWidth: 600,
          maxHeight: '100%',
          backgroundColor: theme.colors.background_2,
          borderRadius: 16,
          overflow: 'hidden',
        }}
      >
        <ScrollView
          keyboardShouldPersistTaps="handled"
          contentContainerStyle={styles.scrollContainer}
          style={{ width: '100%' }}
          showsVerticalScrollIndicator={false}
        >
          <View style={styles.bodyContainer}>{renderBody()}</View>
        </ScrollView>
      </View>

      <Toast config={toastConfig} />
    </Modal>
  );
};

const stylesheet = createStyleSheet((theme) => ({
  outsideModalButton: {
    flex: 1,
    justifyContent: 'flex-end',
  },
  scrollContainer: {
    flexGrow: 1,
    width: '100%',
    alignItems: 'center',
  },
  bodyContainer: {
    alignItems: {
      sm: 'center',
    },
    maxWidth: {
      xs: '100%',
      sm: 600,
      md: 800,
    },
    width: {
      md: 600,
    },
  },
  map: {
    position: 'absolute',
    width: '100%',
  },
  container: {
    flex: 1,
    justifyContent: 'flex-end',
    paddingLeft: theme.paddingOffset,
    paddingRight: theme.paddingOffset,
    paddingBottom: 40,
    gap: 40,
  },
  titleContainer: {
    justifyContent: 'center',
    gap: 16,
  },
  buttonsContainer: {
    gap: 16,
  },
}));
